// EVES-5262: changes of function session identifier filter and column helpers
import { Identifier } from "@/services/models/session";
import { filterSelector } from "@/common/constants/constants";
import { Filters } from "@/common/enums/enums";
import { columnsType } from "@/common/models/model";
import { TFunction } from "i18next";

export type { Identifier };

export const SESSION_IDENTIFIER_BADGE_CONFIG: Record<
  Identifier,
  { labelKey: string; type: string }
> = {
  APP: { labelKey: "transactions.identifier_app", type: "sessionIdentifierApp" },
  RFID: { labelKey: "transactions.identifier_rfid", type: "sessionIdentifierRfid" },
  IVR: { labelKey: "transactions.identifier_ivr", type: "sessionIdentifierIvr" },
  EXTERNAL: { labelKey: "transactions.identifier_external", type: "sessionIdentifierExternal" },
};

// EVES-5262: changes of function mapSessionIdentifierFilterSelection
export const mapSessionIdentifierFilterSelection = (
  selectedItems: string[]
): Identifier[] =>
  selectedItems.map((item) => filterSelector[Filters.SESSION_IDENTIFIER].value[item]);

// EVES-5262: changes of function appendSessionIdentifierFilter
export const appendSessionIdentifierFilter = (
  params: Record<string, unknown>,
  identifierFilter: Identifier[]
): void => {
  if (identifierFilter.length > 0) {
    params.Identifier = identifierFilter.join("|");
  }
};

// EVES-5262: changes of function getSessionIdentifierColumn
export const getSessionIdentifierColumn = (translate: TFunction): columnsType => ({
  id: "identifier",
  label: translate("transactions.identifier"),
  minWidth: 80,
  textAlign: "center",
  maxWidth: 120,
  allowSort: false,
  projectField: "identifier",
  enableTooltip: false,
});

// EVES-5262: changes of function getSessionIdentifierBadgeProps
export const getSessionIdentifierBadgeProps = (
  identifier: string | undefined,
  translate: TFunction
): { label: string; type: string } | null => {
  if (!identifier) {
    return null;
  }
  const normalized = identifier.toUpperCase() as Identifier;
  const config = SESSION_IDENTIFIER_BADGE_CONFIG[normalized];
  if (!config) {
    return null;
  }
  return {
    label: translate(config.labelKey),
    type: config.type,
  };
};
